import React from "react";
import { Menu, X } from "lucide-react";

const Navbar = ({
  isDarkMode,
  toggleDarkMode,
  activeSection,
  scrollToSection,
  isMenuOpen,
  setIsMenuOpen,
}) => {
  return (
    <nav
      className={`fixed top-0 w-full backdrop-blur-lg shadow-lg z-50 transition-all duration-300 ${
        isDarkMode
          ? "bg-gray-900/80 border-gray-700"
          : "bg-white/80 border-gray-200"
      } border-b`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">
          <div 
            className="cursor-pointer" 
            onClick={() => scrollToSection("home")}
          >
            <img 
              src="/assets/logo.png" 
              alt="Logo" 
              className="h-16 w-auto object-contain hover:scale-105 transition-transform duration-300" 
            />
          </div>

          <div className="flex items-center gap-4">
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              {[
                "home",
                "about",
                "education",
                // "certifications",
                "services",
                "projects",
                "experience",
                "contact",
              ].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className={`relative capitalize transition-all duration-300 font-medium ${
                    activeSection === item
                      ? "text-blue-600 scale-110"
                      : isDarkMode
                      ? "text-gray-300 hover:text-blue-400"
                      : "text-gray-700 hover:text-blue-600"
                  }`}
                >
                  {item === "home" ? "Home" : item}
                  {activeSection === item && (
                    <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full"></div>
                  )}
                </button>
              ))}
            </div>

            {/* Enhanced Dark Mode Toggle */}
            <button
              onClick={toggleDarkMode}
              className={`relative p-2 rounded-full transition-all duration-500 transform hover:scale-110 ${
                isDarkMode
                  ? "bg-gray-800 shadow-lg shadow-gray-900/20"
                  : "bg-white shadow-lg shadow-gray-200/50"
              }`}
            >
              {isDarkMode ? (
                <img 
                  src="/assets/lightThemeLogo.png" 
                  alt="Switch to Light Mode" 
                  className="w-8 h-8 object-contain"
                />
              ) : (
                <img 
                  src="/assets/darkThemeLogo.png" 
                  alt="Switch to Dark Mode" 
                  className="w-8 h-8 object-contain"
                />
              )}
            </button>

            {/* Mobile Menu Button */}
            <button
              className={`md:hidden p-2 rounded-lg transition-all duration-300 ${
                isDarkMode
                  ? "text-gray-300 hover:bg-gray-800"
                  : "text-gray-700 hover:bg-gray-100"
              }`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {/* Enhanced Mobile Menu */}
        {isMenuOpen && (
          <div
            className={`md:hidden border-t transition-all duration-500 transform ${
              isDarkMode
                ? "bg-gray-900/95 border-gray-700"
                : "bg-white/95 border-gray-200"
            }`}
          >
            <div className="py-4 space-y-4">
              {[
                "home",
                "about",
                "education",
                "certifications",
                "services",
                "projects",
                "experience",
                "contact",
              ].map((item, index) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className={`block w-full text-left px-4 py-3 capitalize transition-all duration-300 rounded-lg mx-4 ${
                    isDarkMode
                      ? "text-gray-300 hover:text-blue-400 hover:bg-gray-800"
                      : "text-gray-700 hover:text-blue-600 hover:bg-gray-50"
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {item === "home" ? "Home" : item}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
